/**
 * Standalone persona grid — the v1 "home" screen, preserved at /coaches
 * after the 7g navigation refactor moved the root to a project list.
 *
 * Renders the v1 persona selection experience (pick a coach, chat in
 * single-persona mode with no project context). Since §7h shipped
 * standalone roundtable support at /coaches/roundtable, the page also
 * surfaces a secondary "Start a roundtable" button that opens the
 * PanelPicker modal for a multi-persona debate without needing a
 * project container.
 */

import { useEffect, useState } from "react";
import Header from "../components/Header.jsx";
import PersonaCard from "../components/PersonaCard.jsx";
import LoadingSkeleton from "../components/LoadingSkeleton.jsx";
import ErrorBubble from "../components/ErrorBubble.jsx";
import PanelPicker from "../components/PanelPicker.jsx";
import { useStore } from "../store/useStore.js";

export default function Coaches() {
  const personas = useStore((s) => s.personas);
  const loading = useStore((s) => s.personasLoading);
  const error = useStore((s) => s.personasError);
  const loadPersonas = useStore((s) => s.loadPersonas);

  const [panelPickerOpen, setPanelPickerOpen] = useState(false);

  useEffect(() => {
    loadPersonas();
  }, [loadPersonas]);

  return (
    <>
      <Header />
      <main className="home">
        <div className="container">
          <div className="home-intro">
            <h1>
              Choose your <span className="accent">coach</span>
            </h1>
            <p>
              Each persona has been built from deep research into their actual
              frameworks, language, and decision-making style. Or{" "}
              <button
                type="button"
                className="inline-link"
                onClick={() => setPanelPickerOpen(true)}
              >
                start a roundtable
              </button>{" "}
              with 2–3 of them.
            </p>
          </div>

          {error && <ErrorBubble message={error} />}

          <div className="persona-grid">
            {loading && personas.length === 0
              ? Array.from({ length: 6 }).map((_, i) => (
                  <LoadingSkeleton key={i} variant="card" />
                ))
              : personas.map((p) => <PersonaCard key={p.id} persona={p} />)}
          </div>
        </div>
      </main>

      <PanelPicker
        open={panelPickerOpen}
        projectId={null}
        onClose={() => setPanelPickerOpen(false)}
      />
    </>
  );
}
